// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2Q5Em","messages":"Chat_messages__2BlOB","dateDivider":"Chat_dateDivider__wtFT1"};